import React, { useState, useRef } from 'react';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ContextualHelpModule } from '@qbe/ads-blocks-forms';
import { IconButton, styled } from '@qbe/ads-core';

interface InformationPopUpProps {
  title?: string;
  message?: string;
  dataTrack?: string;
}

const InformationPopUpWrapper = styled('div')`
  display: inline-block;
  vertical-align: middle;
  margin-left: 4px;
  margin-top: 4px;
`;

const StyledContextualHelpModule = styled(ContextualHelpModule)`
  .contextual-help-module-container {
    background-color: #fff;
  }
  .contextual-help-module-container .contextual-help-module-content {
    font-weight: normal;
    font-size: 1rem;
  }
  .contextual-help-module-container svg > path {
    color: #000;
    box-shadow: none;
    border-radius: 50%;
  }
`;

export const InformationPopUp = ({ message, dataTrack }: InformationPopUpProps) => {
  const [show, toggle] = useState(false);
  const ref = useRef(null);
  const { isMobile } = useBreakpoint();

  useOnClickOutside(ref, () => isMobile && toggle(false));

  return (
    <InformationPopUpWrapper ref={ref}>
      <IconButton
        data-track={dataTrack || message}
        iconProps={{
          muiIcon: InfoOutlinedIcon,
        }}
        onBlur={(e) => {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
        onClick={() => toggle(!show)}
      />
      <StyledContextualHelpModule
        isOpen={show}
        handleClose={() => {
          toggle(!show);
        }}
        offsetX="620px"
      >
        {message}
      </StyledContextualHelpModule>
    </InformationPopUpWrapper>
  );
};

export default InformationPopUp;
